import React, { useEffect, useState, useCallback } from "react";
import { Dialog, DialogContent, Alert, AlertTitle } from "@mui/material"; export const DialogUnauthorized = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  const handleUnauthorized = useCallback((e) => {
    const error = e.detail;
    setTitle(error?.response?.data?.message?.detail || "Sessão Expirada");
    setMessage(error?.response?.data?.message || "Existe outra sessão ativa em um dispositivo ou navegador para este usuário.");
    setOpen(true);
  }, []);

  useEffect(() => {
    window.addEventListener("unauthorized", handleUnauthorized);
    return () => {
      window.removeEventListener("unauthorized", handleUnauthorized);
    };
  }, [handleUnauthorized]);

  const handleClose = () => setOpen(false);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: "transparent",
          boxShadow: "none",
          borderRadius: 10
        },
      }}
    >
      <DialogContent
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Alert severity="info" sx={{ textAlign: "left", color: "#000" }}>
          <AlertTitle>{title}</AlertTitle>

          {message}
        </Alert>
      </DialogContent>
    </Dialog>
  );
};
